/**
 * Why a configured deposit could not be turned into an amount. Recorded on the
 * booking so staff can see a deposit was expected but not taken, rather than the
 * booking looking like one that never required a deposit.
 */
export enum DepositUnresolvedReason {
  MissingTreatmentCost = 'missingTreatmentCost',
  MissingDepositAmount = 'missingDepositAmount',
}
